'use strict';

var _ = require('lodash');
var GridToolbarDataExtractScheduledController = function GridToolbarDataExtractScheduledController($scope) {
  $scope.isDeleteButtonShown = false;
  $scope.isEditButtonShown = false;
  $scope.isRunButtonShown = false;
  $scope.isSeparatorShown = false;
  $scope.selectedRows = null;
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.isEditButtonShown = selectedRows.length === 1;
    $scope.isRunButtonShown = selectedRows.length === 1;
    $scope.isSeparatorShown = $scope.isDeleteButtonShown || $scope.isEditButtonShown;
    $scope.selectedRow = selectedRows.length === 1 ? selectedRows[0] : null;
  };
  $scope.createNew = function () {
    $scope.$emit('data-extract:newExtract', getExtractNames());
  };
  $scope.deleteSelected = function () {
    $scope.$emit('data-extract:deleteSelectedScheduled', $scope.selectedRows);
  };
  $scope.editExtract = function () {
    $scope.$emit('data-extract:editExtract', $scope.selectedRow);
  };
  $scope.runExtract = function () {
    $scope.$emit('data-extract:runExtract', $scope.selectedRow);
  };
  function getExtractNames() {
    var rows = $scope.jqxGridSettings.jqxGrid('getrows');
    return _.map(rows, function (row) {
      return row.extractName;
    });
  }
};
GridToolbarDataExtractScheduledController.$inject = ['$scope'];
module.exports = GridToolbarDataExtractScheduledController;